import { CRITICAL_ACTION_CODE } from '../../../../../../_constants';

export const checkIsCriticalAction = (code: number): boolean => {
  return !!window.ENVS.MFA_CHECK_ENABLE && code === CRITICAL_ACTION_CODE;
};
